export const LANG = {
    de: {
        tabCalendar: 'Kalender',
        tabLogin: 'Login / Registrierung',
        tabLoggedIn: 'Dein Login Bereich',
        formEmail: 'Email',
        formPassword: 'Passwort',
        formPassword2: 'Passwort (Kontrolle)',
        formBtnLogin: 'Anmelden',
        formBtnRegister: 'Registrieren',
        formBtnReserve: 'Reservieren',
        formBtnShow: 'Anzeigen',
        formSurname: 'Vorname',
        formLastname: 'Nachname',
        formStreet: 'Strasse',
        formPlz: 'PLZ',
        formCity: 'Ort',
        formPhone: 'Telefon',
        formCountry: 'Land',
        formTimeFrom: 'Zeit von',
        formTimeTo: 'Zeit bis',
        formTitle: 'Bezeichnung: (optional)',
        formState: 'Status',
        formDateFrom: 'Datum von: (optional)',
        formDateTo: 'Datum bis: (optional)',
        formDateFrom2: 'Datum von:',
        formDateTo2: 'Datum bis:',
        formDays: 'Tage: (optional)',
        calendarText: {
            register: 'Noch nicht Registriert?',
            registerLink: 'Jetzt registrieren',
            passwordReset: 'Passwort vergessen?',
            passwordResetLink: 'Hier zurücksetzen',
            headerLogin: 'Login',
            headerRegister: 'Registrierung',
            headerReserve: 'Reservierung',
            headerUserEvents: 'Deine Reservierungen',
            headerAdminEvents: 'Reservierungen',
            noReservations: 'Aktuell keine Reservierungen vorhanden.',
            hello: 'Hallo',
            greeting: 'Schön, das Du wieder hier bist.',
            privacy: 'Datenschutz',
        },
        buttons: {
            delete: 'löschen',
        },
        errors: {
            overlap: 'Die ausgewählte Zeitkombination ist nicht möglich!',
            recurring: 'Die ausgewählte Zeitkombination ist nicht möglich!',
            past: 'Reservierungen in der Vergangenheit machen keinen Sinn?',
        },
        success: {
            register: '<p class="success">Danke, Deine Registrierung wurde erfolgreich durchgeführt.</p>\n' +
                '<p>Deine Anmeldung muss noch mit der Verifizierung deiner Email Adresse abgeschlossen werden.\n' +
                'Du solltest in diesem Moment eine Email von unserem System erhalten.\n' +
                'Bitte gegebenfalls auch in deinem Spam Ordner nachschauen!</p>'
        },
        notes: {
            recurring: 'Nur notwendig, falls es ein wiederholendes Ereignis sein soll.',
            registerFirst: '<p>Bitte registriere dich,<br>um Platzreservierungen durchführen zu können!</p>'
        }
    },
    en: {
        tabCalendar: 'Calendar',
        tabLogin: 'Login / Register',
        tabLoggedIn: 'User area',
        formEmail: 'Email',
        formPassword: 'Password',
        formPassword2: 'Password (Confirmation)',
        formBtnLogin: 'Login',
        formBtnRegister: 'Register',
        formBtnReserve: 'Reservation',
        formBtnShow: 'Show',
        formSurname: 'First Name',
        formLastname: 'Last Name',
        formStreet: 'Street',
        formPlz: 'Post Code',
        formCity: 'City',
        formPhone: 'Phone',
        formCountry: 'Country',
        formTimeFrom: 'Time from',
        formTimeTo: 'Time end',
        formTitle: 'Title: (optional)',
        formState: 'Status',
        formDateFrom: 'Date from: (optional)',
        formDateTo: 'Date to: (optional)',
        formDateFrom2: 'Date from:',
        formDateTo2: 'Date to:',
        formDays: 'Days: (optional)',
        calendarText: {
            register: 'No account yet?',
            registerLink: 'Sign up here',
            passwordReset: 'Forgot password?',
            passwordResetLink: 'Reset here',
            headerLogin: 'Login',
            headerRegister: 'Register',
            headerReserve: 'Reservations',
            headerUserEvents: 'Your Reservations',
            headerAdminEvents: 'Reservations',
            noReservations: 'No data available.',
            hello: 'Hi',
            greeting: 'Welcome back.',
            privacy: 'Privacy Policy',
        },
        buttons: {
            delete: 'delete',
        },
        errors: {
            overlap: 'This time combination is not possible!',
            recurring: 'This time combination is not possible!',
            past: 'Reservations in the past doesn\'t make sense?',
        },
        success: {
            register: '<p class="success">Thank you, your registration has been successfully completed.</p>\n' +
                '<p>Your registration must be completed with the verification of your email address.\n' +
                'You should receive an email from our system at this moment.\n' +
                'Please also check your spam folder!</p>'
        },
        notes: {
            recurring: 'Only required for recurring events.',
            registerFirst: '<p>Please register first!</p>'
        }
    }
}